export const initFlixxCounter = function (config) {

  /**
   * Delay function
   */
  let delay = function (time = 0) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  if ($('.flixx_counter').length > 0) {
    $('.flixx_counter').each(function () {
      $(this).on('classChange', async function () {
        if ($(this).hasClass('isVisible')) {
          if (!$(this).hasClass('alreadyAnimated')) {
            await delay(1200);
            $('span.counter', this).each(function () {
              $(this).prop('Counter', 0).animate({
                Counter: parseInt($(this).attr('data-count-to'))
              }, {
                duration: 1600,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now));
                }
              });
            });
            $(this).addClass('alreadyAnimated');
          }
        }
      });
    });
  }

}
